import React from 'react';
export var useBlockScroll = function useBlockScroll(active, container) {
  var containerRef = React.useRef(null);
  var headerContainerRef = React.useRef(null);
  React.useEffect(function () {
    containerRef.current = container !== null && container !== void 0 ? container : window.document.body;
    headerContainerRef.current = document.querySelector('[data-component="site-header-container"]');
  }, []);
  React.useEffect(function () {
    var bodyContainer = containerRef.current;
    var headerContainer = headerContainerRef.current;
    if (bodyContainer && headerContainer) {
      var prevOverflow = bodyContainer.style.overflow;
      var prevHeaderWidth = headerContainer.style.width;
      var scrollWidth = window.innerWidth - bodyContainer.clientWidth;
      if (active) {
        bodyContainer.style.marginRight = "".concat(scrollWidth, "px");
        headerContainer.style.width = "calc(100% - ".concat(scrollWidth, "px)");
        bodyContainer.style.overflow = 'hidden';
      }
      return function () {
        bodyContainer.style.overflow = prevOverflow;
        headerContainer.style.width = prevHeaderWidth;
        bodyContainer.style.marginRight = '';
      };
    }
    return undefined;
  }, [active]);
};